import {useQuery} from 'react-query';
import {getSummerySupplierInfo} from './getSummerySupplierInfo';
import {IGetSummerySupplierInfo} from './types';

const useGetSummerySupplierInfo = (enabled: boolean) => {
  const {data, isLoading, refetch} = useQuery<IGetSummerySupplierInfo>(
    ['get-summery-supplier-info'],
    getSummerySupplierInfo,
    {
      enabled: enabled,
    },
  );
  return {data, isLoading, refetch};
};

export default useGetSummerySupplierInfo;
